import {
	ADD_TIME_LINE,
	DEL_TIME_LINE,
	ADD_TIME_VALUE,
	DEL_TIME_VALUE,
	MODIFY_TIME_VALUE,
	MODIFY_TIME_SCALE,
	MODIFY_TIME_ITEM,
	SET_CURRENT_DRAGITEM,
	ADD_CURRENT_VIDEOINFO,
	MODIFY_CURRENT_TIME,
	DEL_DRAG_ITEM,
	CLEAR_TIME_LINE,
	SAVE_CANVAS_INFO,
	DEL_SUBTITLE,
	MODIFY_SUBTITLE,
	DEL_SUBTITLE_LINE
} from '../constact'
import {isObject, isArray, getNewInfo2, uuid, compareSort} from '../../utils'

const defaultState = {
	trackerLineList: [], // 轨道列表
	timelineScaleWidth: 100, // 轨道每秒宽度
	currentDragItem: {}, // 当前选中的元素(currentId:id, currentChild:st_content)及当前轨道的数据
	currentTime: 0, //当前时间
	currentTimeChangeFrom: 'pause', // 指针位置改变记录来源类型 pointer || play || playing || pause
	currentVideoInfo: {}, // 当前传入的视频 TODO改数组
	canvasPlayInfo: {}
}
export function addTimeLine(data) {
	return {
		type: ADD_TIME_LINE,
		data
	}
}
export function addTimeValue(data) {
	return {
		type: ADD_TIME_VALUE,
		data
	}
}
export function delTimeLine(data) {
	return {
		type: DEL_TIME_LINE,
		data
	}
}
export function delTimeValue(data) {
	return {
		type: DEL_TIME_VALUE,
		data
	}
}
export function modifyTimeValue(data) {
	return {
		type: MODIFY_TIME_VALUE,
		data
	}
}
export function modifyTimeScale(data) {
	return {
		type: MODIFY_TIME_SCALE,
		data
	}
}
export function modifyTimeItem(data) {
	return {
		type: MODIFY_TIME_ITEM,
		data
	}
}
export function setCurrentDragItem(data) {
	return {
		type: SET_CURRENT_DRAGITEM,
		data
	}
}
export function addCurrentVideoInfo(data) {
	return {
		type: ADD_CURRENT_VIDEOINFO,
		data
	}
}
export function modifyCurrentTime(data) {
	return {
		type: MODIFY_CURRENT_TIME,
		data
	}
}
export function delDragItem(data) {
	return {
		type: DEL_DRAG_ITEM,
		data
	}
}
export function clearTimeline() {
	return {
		type: CLEAR_TIME_LINE,
	}
}

export function saveCanvasPlay(data) {
	return {
		type: SAVE_CANVAS_INFO, // 时间canvas对应关系
		data
	}
}

export function delSubtitle(data) {
	return {
		type: DEL_SUBTITLE,
		data
	}
}
export function delSubtitleLine(data) {
	return {
		type: DEL_SUBTITLE_LINE,
		data
	}
}
export function modifySubtitle(data) {
	return {
		type: MODIFY_SUBTITLE,
		data
	}
}


// trackerLineList = [
// 	{
// 		id: '创建时间戳',
// 		st_type: 'subtitle/image',
// 		info: [{
// 			st_content: '字幕/图片url',
// 			startTime: '开始时间',
// 			endTime: '结束时间',
// 			trackX: 0, 相对轨道水平位置
// 			trackY: 0, 相对轨道垂直位置
// 			screenX: 0,
// 			screenY: 0,
// 			width: 100,
// 			height: 40,
// 		}],
// 	}
// ]

const timeLine = (state = defaultState, action) => {
	if(action.type === SET_CURRENT_DRAGITEM) {
		const newState = JSON.parse(JSON.stringify(state))
		newState.currentDragItem = action.data
		return newState
	}
	if(action.type === ADD_TIME_LINE) {
		// 在某个位置插入轨道  action.data= {value: {st_type: '', st_content: '文字或图片url'}, index: index}}
		const newState = JSON.parse(JSON.stringify(state))
		const data = action.data
		const id = uuid()
		data.value.info.map(item => {
			item.id = uuid()
		})
		if(data.index !== '') {
			if(data.index === 1000000) {
				// 覆盖原有的
				newState.trackerLineList.map ((item, index) => {
					if(item.st_type === 'subtitle') {
						newState.trackerLineList.splice(index,1)
					}
				})
				newState.trackerLineList.push({...data.value, id})
			} else {
				// 中间插入
				newState.trackerLineList.splice(data.index, 0, {...data.value, id})
			}
		} else {
			// 尾部追加
			newState.trackerLineList.push({...data.value, id})
		}
		return newState
	}
	if(action.type === DEL_TIME_LINE) {
		const newState = Object.assign({}, state)
		newState.trackerLineList.splice(action.data,1)
		return newState
	}
	if(action.type === ADD_TIME_VALUE) {
		// 给某个轨道添加元素 action.data= {value: {startTime: '', endTime:'', st_content: '文字或图片url'},index: index}
		const newState = JSON.parse(JSON.stringify(state))
		const data = action.data
		console.log(data)
		// 单个字幕
		if(isObject(data.value)) {
			newState.trackerLineList[data.index].info.push({...data.value, id: uuid()})
		}
		// 多个字幕
		if(isArray(data.value)) {
			console.log('isArray',data)
			data.value.map(item => {
				// console.log('item',item)
				item.id = uuid()
			})
			// 根据时间 决定顺序
			const historyInfo = newState.trackerLineList[data.index].info
			if(Number(historyInfo[0].startTime) > Number(data.value[0].startTime)) {
				// unshift
				newState.trackerLineList[data.index].info.unshift(...data.value)
			} else {
				newState.trackerLineList[data.index].info.push(...data.value)
			}

		}
		console.log(newState)
		return newState
	}
	if(action.type === DEL_TIME_VALUE) {
		// 某个轨道删除元素 action.data= {childIndex: childIndex,index: index}
		const newState = Object.assign({}, state)
		const data = action.data
		newState.trackerLineList[data.index].splice(data.childIndex,1)
		return newState
	}
	if(action.type === MODIFY_TIME_VALUE) {
		const newState = JSON.parse(JSON.stringify(state))
		const data = action.data
		console.log(data.value)
		newState.trackerLineList[data.index] = data.value
		newState.trackerLineList[data.index].info.sort(compareSort('startTime'))
		return newState
	}
	if(action.type === MODIFY_TIME_SCALE) {
		const newState = JSON.parse(JSON.stringify(state))
		newState.timelineScaleWidth = action.data
		if(newState.trackerLineList.length > 0) {
			newState.trackerLineList.map(item => {
				item.info.length > 0 && item.info.map(infoItem => {
					infoItem.trackX = (Number(infoItem.startTime) * action.data).toFixed(0)
					// console.log(parseInt((parseFloat(infoItem.endTime) - parseFloat(infoItem.startTime)) * action.data))
					infoItem.width = `${parseInt((parseFloat(infoItem.endTime) - parseFloat(infoItem.startTime)) * action.data)}`
				})
			})
		}
		return newState
	}
	if(action.type === MODIFY_TIME_ITEM) { // 修改单个时间分片的信息
		const newState = JSON.parse(JSON.stringify(state))
		const { parentIndex, id, value } = action.data
		const targetLine = newState.trackerLineList[parentIndex]
		targetLine.info.map((item, i) => {
			if (item.id === id) {
				targetLine.info[i] = value
			}
		})
		return newState
	}

	if(action.type === ADD_CURRENT_VIDEOINFO) {
		// 添加视频信息及生成初始轨道
		const newState = JSON.parse(JSON.stringify(state))
		newState.currentVideoInfo = action.data
		const trackerLineList = []
		const value = {
			id: uuid(),
			st_type: 'video',
			info: [{
				height: 70,
				screenX: 0,
				screenY: 0,
				st_content: action.data.st_fileurl,
				endTime: (action.data.duration / 1000),
				startTime: 0,
				trackX: 0,
				trackY: 0,
				videoWidth: action.data.width,
				videoHeight: action.data.height,
				width: (action.data.duration / 1000) * newState.timelineScaleWidth
			}]
		}
		if(trackerLineList.length === 0 || trackerLineList[0].st_type !== 'video') {
			trackerLineList.unshift(value)
		} else if (trackerLineList.length > 0 &&  trackerLineList[0].st_type === 'video') {
			trackerLineList.splice(0,1,value)
		}
		const subtitles = action.data.st_senior_subtitles
		if(subtitles && !action.data.st_fileurl) {
			subtitles.info.map(item => {
				item.st_content= item.st_content.replace(/\\n/g,'')
			})
			trackerLineList.push({
				id: uuid(),
				info: subtitles.info,
				st_type: 'subtitle'
			})
		}
		newState.trackerLineList = trackerLineList
		return newState
	}
	if(action.type === MODIFY_CURRENT_TIME) {
		const newState = JSON.parse(JSON.stringify(state))
		if(newState.currentTimeChangeFrom === 'pointer' && action.data.from === 'playing' ){
			//	播放中点击时间抽 （不更新时间=》 暂停后会有延迟）
		} else {
			newState.currentTime = action.data.currentTime
			newState.currentTimeChangeFrom = action.data.from
		}
		return newState

	}
	if(action.type === DEL_DRAG_ITEM) {
		const newState = JSON.parse(JSON.stringify(state))
		const currentDragItem = newState.currentDragItem
		if(!currentDragItem.info) return newState
		const infoLen = currentDragItem.info.length
		if(infoLen > 0 && infoLen !== 1) {
			newState.trackerLineList[currentDragItem.parentIndex].info.map((item, index) => {
				if(item.id === currentDragItem.currentChildId) {
					newState.trackerLineList[currentDragItem.parentIndex].info.splice(index, 1)
				}
			})
		} else if(infoLen === 1) {
			newState.trackerLineList.splice(currentDragItem.parentIndex, 1)
		}
		return newState
	}
	if(action.type === CLEAR_TIME_LINE) {
		const newState = JSON.parse(JSON.stringify(state))
		newState.trackerLineList =[]
		newState.timelineScaleWidth = 100
		newState.currentDragItem = {}
		newState.currentTime = 0
		newState.currentTimeChangeFrom = 'pause'
		newState.currentVideoInfo = {}
		return newState
	}

	if(action.type === SAVE_CANVAS_INFO) {
		const newState = JSON.parse(JSON.stringify(state))
		newState.canvasPlayInfo = action.data
		return newState
	}
	if(action.type === DEL_SUBTITLE) {
		const newState = JSON.parse(JSON.stringify(state))
		const {pIndex, index} = action.data
		const subtitleList = newState.trackerLineList[pIndex].info
		subtitleList.splice(index,1)
		if(subtitleList.length === 0) newState.trackerLineList.splice(pIndex,1)
		return newState
	}
	if(action.type === MODIFY_SUBTITLE) {
		const newState = JSON.parse(JSON.stringify(state))
		const {pIndex, index,type, data} = action.data
		const subtitleList = newState.trackerLineList[pIndex].info
		Object.keys(data).map(key => {
			subtitleList[index][key] = data[key]
		})
		// console.log(subtitleList[index])
		// console.log(subtitleList)
		if(type === 'time') {
			console.log(getNewInfo2(index,subtitleList,newState.timelineScaleWidth))
			newState.trackerLineList[pIndex].info = getNewInfo2(index,subtitleList,newState.timelineScaleWidth)
		}
		return newState
	}
	if(action.type === DEL_SUBTITLE_LINE) {
		const newState = JSON.parse(JSON.stringify(state))
		const trackerLineList = newState.trackerLineList
		trackerLineList.map((item, index) => {
			if(item.st_type === 'subtitle') {
				trackerLineList.splice(index,1)
			}
		})
		return newState
	}
	return state
}
export default timeLine